export const getters = {
  getRule: state => {
    return state.rules
  },
  gethasId: state => {
    return state.hasId
  }
}



// WEBPACK FOOTER //
// ./src/stores/rules/getters.js